import React from 'react'

export default function WeddingEmotion() {
  return (
    <>
    <section className="homegrace mt-0">
        <div className="homegrace-text">
            <h3 className='heading'>Where Elegance Meets Emotion</h3>
        </div>

        <img src="/image/wedding-emotion.webp" className="img-responsive" alt="wedding" loading="lazy"/>
        <div className="homegrace-overlay"></div>
    </section> 
    </>
  )
}
